<template>
  <modal :show="show" @close="close">
    <div id="patient-error-modal" slot="header" class="modal-header">
      <h5 class="modal-title">Entered a Patient Barcode</h5>
      <button id="btn-patient-error-close" type="button" class="close" @click="close" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div slot="body">
      The entered barcode belongs to a patient and not a ventilator. Would you like to Start a New Association for
      {{ scannedEntity | getPatientFullName }}?
    </div>

    <template v-slot:footer>
      <button id="btn-cancel" class="btn btn-light" @click="close">
        Cancel
      </button>
      <button id="btn-keep-change-confirm" class="btn btn-primary" @click="handleNewAssociation">
        Start a New Association
      </button>
    </template>
  </modal>
</template>

<script>
import Modal from "../Modal";

export default {
  name: "PatientErrorModal",
  props: ["show", "scannedEntity"],
  mounted() {
    console.log(this.show);
    console.log(this.scannedEntity);
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleNewAssociation() {
      this.$emit("startNewAssociation");
      this.$emit("close");
    }
  },
  components: {
    modal: Modal
  }
};
</script>

<style scoped></style>
